module.exports = __webpack_public_path__ + "img/cerebro.65ac706b.png";